import React, { useState, useEffect } from "react"

import "../../styles/Common/DynamicCard.less"
import CircleIcon from "./CircleIcon"

import { observer } from "mobx-react"
import AppStore from "../../Configs/Store"
import BenefitStore from "../../Configs/Store/benefit"
import FormStore from "../../Configs/Store/forms"
import { scrollToClassHorizon } from "../Common/CommonFunctions"

const DynamicCard = observer((props) => {
  const device = AppStore.device
  const detailedMode = BenefitStore.detailedMode
  const setDetailedMode = BenefitStore.setDetailedMode
  const [cardCollapsed, setCollapsed] = useState(true)
  const [addEvent, setAddEvent] = useState(false) // Fund Performance Event

  useEffect(() => {
    if (cardCollapsed && !addEvent) {
      setTimeout(addEventForFP, 1000)
    }
  }, [detailedMode])

  const scrollToFP = () => {
    // console.info("Scroll FpRoot")
    BenefitStore.setModalMode(false)
    scrollToClassHorizon("FpRoot")
  }

  const addEventForFP = () => {
    var elements = document.querySelectorAll(".KeyBenHYPFP")

    if (elements.length !== 0) {
      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener("click", scrollToFP, false)
      }
      setAddEvent(true)
    }
  }

  let wrapper = props.wrapperStyle
  let titleBodyWrapper = props.titleBodyWrapperStyle
  let title = props.titleStyle
  let content = props.contentStyle
  let dot = props.dotStyle
  let arrowUrl = props.arrowUrl
  let arrowStyle = props.arrowStyle
  let icon = props.iconStyle
  let forDataLayer = props.dataLayerEvent

  if (device === 1) {
    if (detailedMode) {
      if (cardCollapsed && props.expandable) {
        wrapper = "HideCard"
      } else if (props.expandable) {
        wrapper = "DynamicCardPCWrapperExpanded"
        title = "DynamicCardTitlePCExpanded"
        arrowStyle = "arrowPCsmExpand"
      }
    }
  }

  const handleExpand = async () => {
    var eventName = forDataLayer.split("|")[0]
    var optionText = forDataLayer.split("|")[1]
    if (cardCollapsed) {
      // DataLayerFn(eventName + "||Calculator-Landing page|Benefits", FormStore, "", "", optionText, "")
    }
    if (!detailedMode) {
      await setDetailedMode(true)
      setCollapsed(false)
      // DataLayerFn("PlanBenefits_PopupOpen||Calculator-Landing page|Plan Benefits", FormStore, "", "", optionText, "")
    }
  }
  const handleCollapse = async () => {
    var optionText = forDataLayer.split("|")[1]
    if (detailedMode) {
      setCollapsed(true)
      await setDetailedMode(false)
    }
  }

  return (
    <div style={props.RootStyle} className={wrapper} onClick={props.expandable && device === 1 ? handleExpand : props.onClick}>
      <div className="iconCrossWrap">
        {props.dot ? <div className={dot}>{props.icon ? <CircleIcon iconStyle={icon} iconUrl={props.data.iconId} /> : ""}</div> : ""}
        {props.cross ? <CircleIcon iconUrl={props.data.iconId} onClick={props.crossOnClick} /> : ""}
      </div>
      <div className={titleBodyWrapper}>
        {props.title ? <h3 className={title} dangerouslySetInnerHTML={{ __html: props.data.title }}></h3> : ""}

        {detailedMode || props.content ? <div className={content} dangerouslySetInnerHTML={{ __html: props.data.content }}></div> : ""}
      </div>
      {props.arrow ? <img src={`assets/${arrowUrl}.svg`} className={arrowStyle} alt={""} onClick={handleCollapse}></img> : ""}
    </div>
  )
})

export default DynamicCard
